import { useIntl } from 'react-intl';

// Model Library Initial Categories
export const useGetModelLibraryCategories = () => {
  const intl = useIntl();
  return [
    {
      value: 'Admin',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.admin',
        defaultMessage: 'Admin',
        description: 'Admin category label',
      }),
    },
    {
      value: 'Business Associate Agreements',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.businessAssociateAgreements',
        defaultMessage: 'Business Associate Agreements',
        description: 'Business Associate Agreements category label',
      }),
    },
    {
      value: 'Compliance and Audits',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.complianceAndAudits',
        defaultMessage: 'Compliance and Audits',
        description: 'Compliance and Audits category label',
      }),
    },
    {
      value: 'Construction',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.construction',
        defaultMessage: 'Construction',
        description: 'Construction category label',
      }),
    },
    {
      value: 'Confidentiality',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.confidentiality',
        defaultMessage: 'Confidentiality',
        description: 'Confidentiality category label',
      }),
    },
    {
      value: 'Custodial Agreements',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.custodialAgreements',
        defaultMessage: 'Custodial Agreements',
        description: 'Custodial Agreements category label',
      }),
    },
    {
      value: 'Data Privacy',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.dataPrivacy',
        defaultMessage: 'Data Privacy',
        description: 'Data Privacy category label',
      }),
    },
    {
      value: 'Employment Agreements',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.employmentAgreements',
        defaultMessage: 'Employment Agreements',
        description: 'Employment Agreements category label',
      }),
    },
    {
      value: 'Energy Service Agreements',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.energyServiceAgreements',
        defaultMessage: 'Energy Service Agreements',
        description: 'Energy Service Agreements category label',
      }),
    },
    {
      value: 'Healthcare',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.healthcare',
        defaultMessage: 'Healthcare',
        description: 'Healthcare category label',
      }),
    },
    {
      value: 'Insurance',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.insurance',
        defaultMessage: 'Insurance',
        description: 'Insurance category label',
      }),
    },
    {
      value: 'Invoice',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.invoice',
        defaultMessage: 'Invoice',
        description: 'Invoice category label',
      }),
    },
    {
      value: 'Intellectual Property',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.intellectualProperty',
        defaultMessage: 'Intellectual Property',
        description: 'Intellectual Property category label',
      }),
    },
    {
      value: 'International Swaps and Derivatives Association',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.internationalSwapsAndDerivativesAssociation',
        defaultMessage: 'International Swaps and Derivatives Association',
        description:
          'International Swaps and Derivatives Association category label',
      }),
    },
    {
      value: 'Lease',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.lease',
        defaultMessage: 'Lease',
        description: 'Lease category label',
      }),
    },
    {
      value: 'Loan Agreements',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.loanAgreements',
        defaultMessage: 'Loan Agreements',
        description: 'Loan Agreements category label',
      }),
    },
    {
      value: 'Mergers and Acquisitions',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.mergersAndAcquisitions',
        defaultMessage: 'Mergers and Acquisitions',
        description: 'Mergers and Acquisitions category label',
      }),
    },
    {
      value: 'Non-Disclosure Agreements',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.nonDisclosureAgreements',
        defaultMessage: 'Non-Disclosure Agreements',
        description: 'Non-Disclosure Agreements category label',
      }),
    },
    {
      value: 'Payer Provider Management',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.payerProviderManagement',
        defaultMessage: 'Payer Provider Management',
        description: 'Payer Provider Management category label',
      }),
    },
    {
      value: 'Receipts',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.receipts',
        defaultMessage: 'Receipts',
        description: 'Receipts category label',
      }),
    },
    {
      value: 'Risk Analysis',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.riskAnalysis',
        defaultMessage: 'Risk Analysis',
        description: 'Risk Analysis category label',
      }),
    },
    {
      value: 'Sales',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.sales',
        defaultMessage: 'Sales',
        description: 'Sales category label',
      }),
    },
    {
      value: 'Vendor',
      label: intl.formatMessage({
        id: 'UseGetModelLibraryCategories.vendor',
        defaultMessage: 'Vendor',
        description: 'Vendor category label',
      }),
    },
  ];
};
